<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="orderInput" formName="orderInput" title="订单录入" />
      <BaseForm ref="orderModify" formName="orderModify" title="订单修改" />
    </qx-card>
    <SubBtnBox @sub="sub"/>
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import ChooseWorker from 'components/choose/worker';
import {
  orderLimitCfgEdit,
  orderLimitCfg,
} from 'api/system';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
    ChooseWorker,
  },
  data () {
    return {
      pageUrl: '/manage/system/risk/order/edit',
      formComponents: ['orderInput', 'orderModify'],
      editParams: {
        nums: 4,
      },
    };
  },
  methods: {
    editApi: orderLimitCfgEdit,

    showUserDialog () {
      this.$refs.chooseWorker.show();
    },
    async detailApi () {
      const orderInputRes = await orderLimitCfg({
        typeName: 'ORDER_INPUT',
      });
      const orderModifyRes = await orderLimitCfg({
        typeName: 'ORDER_MODIFY',
      });
      return {
        orderInput: orderInputRes.items,
        orderModify: orderModifyRes.items,
      };
    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
